import QRCode from 'qrcode.react';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';

import Table1 from '../../../../../components/Common/TableContainer';
import { AssignSampleToTestModal } from './AssignSampleToTestModal';
import { TableItemDeleteModal } from '../../../../../components/Common/TableItemDeleteModal';
import { addNewLabRequestTestSample, deleteLabRequestTestSample, getLabRequestTestSamples } from '../../../../../store/actions';
import { AnalysisRequestNewRegisterButton } from '../../../../../components/Common/AnalysisRequestNewRegisterButton';
import { BaseCustomButton, userRoles } from '../../../../../shared';
import { statuses } from '../../../../../constants';

export const AddSamplesToTestsTab = ({ props }) => { // Props ya es el objeto con la información del row del tab de ensayos

    // Modal para Asignar muestras
    const [showModal1, setShowModal1] = useState(false);
    // Modal de borrar una muestra asignada al ensayo
    const [showModal2, setShowModal2] = useState(false);
    // Para la información de cada renglón
    const [rowInfo, setRowInfo] = useState();
    const role = (localStorage.getItem("authUser")) ? JSON.parse(localStorage.getItem("authUser"))?.role : ''

    // * Redux
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(getLabRequestTestSamples(`?limit=20&page=0&labRequestTest=${props?.match?.params?.rowInfoLabTestViewId}`)); // Sólo obtengo los items que coincidan con el id de "Lab Request" y labTest seleccionado
    }, [])

    const { labRequestTests, labRequestEssays, labRequestTestSamples, labRequestTestSample, loading, total, currentPage } = useSelector(state => ({
        labRequestTestSamples: state.labRequestTestSampleReducer.labRequestTestSamples, // TODO: Ésta variable va en la "data" de la tabla para seleccionar muestras que se van a agregar a cada ensayo
        labRequestTestSample: state.labRequestTestSampleReducer.labRequestTestSample,
        loading: state.labRequestTestSampleReducer.loading,
        total: state.labRequestTestSampleReducer.total,
        currentPage: state.labRequestTestSampleReducer.currentPage,
        labRequestEssays: state.labRequestEssayReducer.labRequestEssays,
        labRequestTests: state.labRequestTestReducer.labRequestTests,
    }), shallowEqual);
    // * Redux fin

    const onDelete = (values) => {
        setRowInfo(values);
        setShowModal2(true);
    }


    const onDeleteConfirmation = () => {
        dispatch(deleteLabRequestTestSample({ id: rowInfo.id }));
        setRowInfo('');
    }

    const getPagination = (params) => {
        dispatch(getLabRequestTestSamples(`${params}&labRequestTest=${props?.match?.params?.rowInfoLabTestViewId}`));
    }

    const modalRespInfo = (values, rowSampleIds) => {
        const arr = []
        rowSampleIds.forEach((element) => {
            arr.push(element)
        });

        dispatch(addNewLabRequestTestSample({
            ...values,
            labRequestTest: props?.match?.params?.rowInfoLabTestViewId,
            labRequestSamples: arr,
        }))

        // Recargar con suficiente tiempo de espera para que la base de datos termine las inserciones
        setTimeout(() => {
            dispatch(getLabRequestTestSamples(`?limit=20&page=0&labRequestTest=${props?.match?.params?.rowInfoLabTestViewId}`));
        }, 1200);
    }

    const columns = React.useMemo(
        () => [
            {
                Header: 'No. muestra',
                width: 400,
                Cell: ({ row }) => (
                    <div>
                        <div className='text-center mb-2'>Código de muestra: {row.original?.labRequestSample?.sampleControlIdentifier ?? '-'}</div>
                        <div className='text-center mb-1'>
                            <QRCode value={row.original?.labRequestSample?.sampleControlIdentifier ?? '-'} size={50} />
                        </div>
                        <div className='text-center'>Folio de muestra: {row.original?.labRequestSample?.serviceIdentifier ?? '-'}</div>
                    </div>
                ),
            },
            {
                Header: 'Descripción de la muestra',
                width: 400,
                Cell: ({ row }) => (
                    <div>
                        <div>{row?.original?.labRequestSample?.name ?? '-'}</div>
                    </div>
                ),
            },
            {
                Header: 'Cantidad',
                width: 400,
                Cell: ({ row }) => (
                    <div>
                        <div>{row?.original?.labRequestSample?.quantity ?? '-'}</div>
                    </div>
                ),
            },
            {
                Header: 'UM',
                width: 400,
                Cell: ({ row }) => (
                    <div>
                        <div>{row?.original?.labRequestSample?.unitMeasure?.name ?? '-'}</div>
                    </div>
                ),
            },
            {
                Header: 'Ensayos por muestra',
                width: 400,
                Cell: ({ row }) => (
                    <div>
                        <div>{row.original?.essays ?? '-'}</div>
                    </div>
                ),
            },
            {
                width: '10%',
                Header: "Acciones",
                Cell: ({ row }) => (
                    <div className="page-title-box d-flex align-items-center justify-content-center">
                        <BaseCustomButton
                            disabled={
                                (role === userRoles.laboratorist) ||
                                (labRequestTests[0]?.labRequest?.generalStatus === statuses.FINISHED) ||
                                (labRequestTests[0]?.labRequest?.generalStatus === statuses.CANCELLED)
                            }
                            className="col-12 mb-2 p-1"
                            icon="mdi-delete mdi-18px"
                            label="Eliminar"
                            color='danger'
                            outline
                            onClick={() => { onDelete(row.original) }}
                        />
                    </div>
                ),
            },
        ],
        [role, labRequestTests]
    )

    return (
        <>
            <div className='d-flex align-items-center justify-content-between'>
                <h4 className='text-center text-primary'>Muestras asignadas al ensayo</h4>
                <AnalysisRequestNewRegisterButton
                  disabled={ (role === userRoles.technicalAdvisor && labRequestTests[0]?.labRequest?.requestStatus !== statuses.SENT_PENDING ) || labRequestTests[0]?.labRequest?.generalStatus === statuses.FINISHED || labRequestTests[0]?.labRequest?.generalStatus === statuses.CANCELLED }
                  showModal={showModal1}
                  text={'Asignar Muestras'}
                  setShowModal={setShowModal1}
                />
                <AssignSampleToTestModal props={props} showModal={showModal1} setShowModal={setShowModal1} modalRespInfo={modalRespInfo} modalHeader='Registro de Muestras' />
            </div>

            <br />

            <Table1 currentPage={currentPage} getPagination={getPagination} total={total} loading={loading} isAddTableBorderStrap columns={columns} data={labRequestTestSamples} />
            <TableItemDeleteModal onDeleteConfirmation={onDeleteConfirmation} props={props} showModal={showModal2} setShowModal={setShowModal2} modalHeader='Eliminar muestra' modalBodyLabel='¿Está seguro que desea eliminar la muestra seleccionada?' />
        </>
    )
}
